import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon18 = Icon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0",
  y: "0",
  enableBackground: "new 0 0 40 40",
  version: "1.1",
  viewBox: "0 0 40 40",
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("defs", {}, void 0, /*#__PURE__*/_jsx("path", {
  id: "SVGID_1_",
  d: "M33 5.8H7C5.6 5.8 4.5 7 4.5 8.5v18c0 1.5 1.1 2.7 2.5 2.7h7.8v2.5H11c-.6 0-1.1.5-1.1 1.2s.5 1.2 1.1 1.2h18c.6 0 1.1-.5 1.1-1.2s-.5-1.2-1.1-1.2h-3.8v-2.5H33c1.4 0 2.5-1.2 2.5-2.7v-18c0-1.4-1.1-2.7-2.5-2.7zM17.1 31.7h5.8v-2.3h-5.8v2.3zm16.2-5.1c0 .2-.1.3-.3.3H7c-.1 0-.3-.1-.3-.3v-18c0-.2.1-.3.3-.3h26c.1 0 .3.1.3.3v18z"
})), /*#__PURE__*/_jsx("use", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  overflow: "visible",
  xlinkHref: "#SVGID_1_"
}), /*#__PURE__*/_jsx("clipPath", {}, void 0, /*#__PURE__*/_jsx("use", {
  overflow: "visible",
  xlinkHref: "#SVGID_1_"
}))));
export default SkholeIcon18;